module.exports = __webpack_public_path__ + "img/my-image (4).81fff8c8.png";